import { useState, useEffect, useRef } from "react";
import {
  Box,
  Modal,
  Fade,
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import CustomSwitch from "../../shared/CustomSwitch";
import SelectedMessageDetails from "../SwiftDay/SelectedMessage/SelectedMessageDetails";

import { useReactToPrint } from "react-to-print";
import PrimaryButton from "../../shared/PrimaryButton";

const style = {
  display: "flex",
  flexDirection: "column",
  position: "absolute",
  top: "20px",
  height: "calc(100vh - 40px)",
  width: "calc(100vw - 40%)",
  marginRight: "20%",
  marginLeft: "20%",
  bgcolor: "#F8FAFB",
  border: "none",
};

const ViewMessages = ({ open, messages, handleClose }) => {
  const messagesDetails = messages.map((message) => message.messageDetails);

  const [showOriginal, setShowOriginal] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);

  const showOriginalToggler = () => {
    setShowOriginal(!showOriginal);
  };

  const messageRef = useRef(null); //component to print ref
  const onBeforeGetContentRef = useRef(); //a ref for a promise resolve

  const handleOnBeforeGetContent = () => {
    return new Promise((resolve) => {
      setIsPrinting(true); //set printing state to true (a dependency for hidden and shown content in the print[])
      onBeforeGetContentRef.current = resolve;
    });
  };

  useEffect(() => {
    if (isPrinting) onBeforeGetContentRef.current();
  }, [isPrinting, onBeforeGetContentRef]);

  const handlePrint = useReactToPrint({
    content: () => messageRef.current,
    documentTitle: "SWIFT Messages",
    onBeforeGetContent: handleOnBeforeGetContent,
    onAfterPrint: () => {
      setIsPrinting(false);
    },
  });

  return (
    <Modal
      open={open}
      onClose={handleClose}
      disableEnforceFocus
      disableAutoFocus
    >
      <Fade in>
        <Box sx={style}>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            sx={{
              height: "64px",
              p: "15px",
              backgroundColor: "#050D2E",
            }}
          >
            <Grid item>
              <Typography
                sx={{ color: "#ffffff", fontSize: "1.25rem", fontWeight: 550 }}
              >
                View Message
              </Typography>
            </Grid>
            <Grid item>
              <CloseIcon
                sx={{ color: "#ffffff", cursor: "pointer" }}
                onClick={handleClose}
              />
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              overflow: "auto",
              marginTop: "initial",
              width: "initial",
              marginLeft: "initial",
              position: "relative",
            }}
          >
            <Grid
              item
              xs={12}
              sx={{
                padding: "1rem",
                position: "sticky",
                top: 0,
                backgroundColor: "#F8FAFB",
                zIndex: 500,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <CustomSwitch
                  value={showOriginal}
                  onChange={showOriginalToggler}
                />
                <Typography
                  sx={{
                    fontSize: ".875",
                    fontWeight: 550,
                    color: "#050D2E",
                    marginLeft: "10px",
                  }}
                >
                  Show Original (RJE)
                </Typography>
                <div style={{ marginLeft: "auto" }}>
                  <PrimaryButton
                    onClick={handlePrint}
                    tooltip="Print"
                    isIconButton
                  >
                    <PrintIcon fontSize="small" />
                  </PrimaryButton>
                </div>
              </Box>
            </Grid>
            <Grid item flexGrow={1} sx={{ padding: "1rem", paddingTop: 0 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  paddingTop: "1rem",
                }}
                ref={messageRef}
              >
                {messagesDetails.map((messageDetails, index) => {
                  const uetr = messages[index].uetr;
                  return (
                    <div key={uetr} className="message">
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          bgcolor: "#ffffff",
                          p: "2px",
                          border: "1px solid #D3D8E3",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "1.5rem",
                            padding: "10px",
                          }}
                        >
                          {messages[index].referenceNumber}
                        </Typography>
                        {showOriginal ? (
                          <div
                            style={{
                              padding: "0px 10px 10px 10px",
                              whiteSpace: "pre-line",
                            }}
                          >
                            {messageDetails.rjeFormat}
                          </div>
                        ) : (
                          <SelectedMessageDetails
                            messageDetails={messageDetails.details}
                            isPrinting={isPrinting}
                          />
                        )}
                      </Box>
                      {index !== messagesDetails.length - 1 ? (
                        <div className="page-break" />
                      ) : null}
                    </div>
                  );
                })}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
};

export default ViewMessages;
